
import { Vue, Component, Prop } from "vue-property-decorator";
import GET_CONTRACTOR_COUNTS from "@/apollo/projects/GetContractorClientVisitsAggregate.gql";
import DefaultContentLayout from "@/components/scaffold/DefaultContentLayoutNew.vue";
import ProjectCollectionFilters from "@/components/companyProjects/ProjectCollectionFiltersNew.vue";
import UIButton from "@/components/button/ui-button.vue";
import ClockIcon from "@/components/icons/clockIconNew.vue";
import ClockIconBlack from "@/components/icons/Clock-icon-black.vue";
import RouteNames from "@/entities/RouteNames";
import { User, Company, Timesheet_Bool_Exp } from "@/generated/graphql";
import ProjectTimeTrackerModal from "@/components/projects/timeTracker/ProjectTimeTrackerModal.vue";
import INSERT_TIMESHEET from "@/apollo/projectActivities/InsertTimesheetEntry.gql";
import { getStartAndEndOfWeek } from "@/utils";
import GET_TIMEHSEET from "@/apollo/timesheet/GetTimesheet.gql";
import moment from "moment";
import PaginationConfig from "@/entities/PaginationConfig";
import paginationConfig from "@/data/paginationConfig";

@Component({
  components: {
    ProjectTimeTrackerModal,
    ClockIconBlack,
    DefaultContentLayout,
    ProjectCollectionFilters,
    UIButton,
    ClockIcon,
  },
  apollo: {
    clients: {
      query: GET_CONTRACTOR_COUNTS,
      variables() {
        return this.clientCountsQueryFilter;
      },
      update(data) {
        this.showLogHours = data.total_projects_aggregate.aggregate.count > 0 ? true : false
        return data;
      },
    },
  },
})
export default class ClientProjects extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Object, required: true }) readonly company!: Company;

  clients = {};
  showLogHours: boolean = false;
  timeTrackerOpen: boolean = false;
  paginationConfig: PaginationConfig = { ...paginationConfig };
  projects: any = 0;

  timesheetWhere(date: Date, activity): Timesheet_Bool_Exp {
    const comapnyId: any = activity.company_id;
    return {
      _and: [{ start_date: { _lte: date } }, { end_date: { _gte: date } }],
      company_id: { _eq: comapnyId },
      contractor_id: { _eq: activity.contractor_id },
    };
  }

  get clientCountsQueryFilter() {
    return {
      currentUserId: this.currentUser.id,
      currentDate: new Date().toISOString().split('T')[0],
    };
  }

  async createTimeSheet(date: Date, activity) {
    const comapnyId: any = activity.company_id;

    const [start, end] = getStartAndEndOfWeek(date);
    try {
      const timesheetRes = await this.$apollo.mutate({
        mutation: INSERT_TIMESHEET,
        variables: {
          timesheet: {
            contractor_id: activity.contractor_id,
            user_id: this.currentUser.id,
            company_id: comapnyId,
            start_date: moment(start).format("YYYY-MM-DD"),
            end_date: moment(end).format("YYYY-MM-DD"),
            type: "WEEKLY",
            status: "UNSUBMITTED",
            tracked_time: 0,
          },
        },
      });
      return timesheetRes.data?.insert_timesheet_one?.id;
    } catch (error) { }
  }

  async checkDateWeekDisable(date: Date, activity) {
    let response = { isDisable: false, id: null };
    const dateMilis = new Date(date).getTime();
    try {
      if (activity?.contractor_id) {
        const timesheetRes = await this.$apollo.query({
          query: GET_TIMEHSEET,
          variables: {
            where: this.timesheetWhere(date, activity),
            distinct_on: "id",
          },
        });
        const timesheet = timesheetRes.data?.timesheet?.[0];
        if (timesheet) {
          const startTime = new Date(timesheet.start_date).getTime();
          const endTime = new Date(timesheet.end_date).getTime();
          const isBetween = dateMilis <= endTime && dateMilis >= startTime;
          response = { isDisable: false, id: timesheet.id };
          if (
            isBetween &&
            timesheet.status !== "REJECTED" &&
            timesheet.status !== "UNSUBMITTED"
          ) {
            response = { isDisable: true, id: null };
          }
        } else {
          const timesheetId = await this.createTimeSheet(date, activity);
          response = { isDisable: false, id: timesheetId };
        }
      } else {
        response = { isDisable: true, id: null };
      }
    } catch (e) {
      response = { isDisable: true, id: null };
    }

    return response;
  }

  get clientAllCount() {
    if (!this.paginationConfig.total && this.paginationConfig.total !== 0) {
      return "";
    }
    return this.paginationConfig.total.toString();
  }

  getAllClientsFromRoute(projects) {
    this.projects = projects.project;
    this.paginationConfig.total = projects.total.aggregate.count;
    this.paginationConfig.loadedCount = projects.length;
  }

  getVisitsFromRoute(projects) {
    this.projects = projects.project;
    this.paginationConfig.total = projects.total_visits.aggregate.count;
    this.paginationConfig.loadedCount = projects.length;
  }

  get openTimeTrackerModal() {
    return (this.timeTrackerOpen = true);
  }

  async closeTimeTrackerModal() {
    this.timeTrackerOpen = false;
  }

  get pageTitle(): string {
    switch (this.$route.name) {
      case RouteNames.CLIENT_VISITS:
        return "Manage Visits";
      case RouteNames.CLIENT_All:
        return "Manage Clients";
      case RouteNames.ALL_VISITS:
        return "Manage Visits";
      case RouteNames.ALL_CLIENTS:
        return "Manage Clients";
      default:
        return "Manage Clients";
    }
  }
}
